import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

const handler = ( $ ) => {
	gsap.registerPlugin( ScrollTrigger );

	const isMobile = () => {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		);
	};

	const initImageAnimation = ( mql ) => {
		const isAnimated = ! isMobile() || ! mql.matches;

		if ( ! isAnimated ) return;

		try {
			const duration = 0.2;

			// New animation for .animated-media
			const mediaSelectors =
				'.animated-media img:not(.animated-decor), .animated-media video:not(.animated-decor), .animated-media iframe:not(.animated-decor), .animated-media image:not(.animated-decor)';
			const $mediaElements = $( mediaSelectors );

			$mediaElements.each( ( i, element ) => {
				if ( $( element ).parents( '#content' ).length == 0 ) {
					return;
				}

				const animationOptions = {
					duration: duration,
					overwrite: true,
					immediateRender: true,
				};

				let st;
				const scrollHandler = () => {
					st = ScrollTrigger.create( {
						trigger: element,
						start: 'top 75%',
						end: 'bottom 25%',
						scrub: true,
						onUpdate: ( self ) => {
							if ( self.isActive ) {
								gsap.to( element, {
									filter: 'grayscale(0)',
									...animationOptions,
								} );
							} else {
								gsap.to( element, {
									filter: 'grayscale(1)',
									...animationOptions,
								} );
							}
						},
					} );

					// Force update ScrollTrigger
					ScrollTrigger.refresh();

					// Remove listener after first initialization
					window.removeEventListener( 'scroll', scrollHandler );
				};

				// Add delayed scroll event handler
				setTimeout( () => {
					window.addEventListener( 'scroll', scrollHandler );
				}, 1000 );

				if ( ! isAnimated ) {
					gsap.set( element, { filter: 'grayscale(0)' } );
					if ( st ) st.kill();
				}
			} );
		} catch ( error ) {
			console.error( 'GSAP animation error:', error );
		}
	};

	const mql = window.matchMedia( '(max-width: 991px)' );

	initImageAnimation( mql );

	mql.addEventListener( 'change', initImageAnimation );
};

export default ( ( $ ) => $( handler ) )( jQuery );
